import React, { useEffect, useRef } from 'react'
import ActiveItemDivider from './ActiveItemDivider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel, Scrollbar } from 'swiper/modules';

const ActiveItemContents = ({parentSwiper, contents }) => {

  const swiperRef = useRef(null);
  const stopParent = () => parentSwiper.current.enabled = false;
  const startParent = () => parentSwiper.current.enabled = true;

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(0);
      swiperRef.current.update();
    }
  }, [contents])

  return (
    <>
      <section className="card-details__card card-details__card--contents" onMouseEnter={stopParent} onMouseLeave={startParent}>
        <h3 className="card-details__title">Pack Contents</h3>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          className='card-details__contents-slider'
          direction={'vertical'}
          slidesPerView={'auto'}
          freeMode={true}
          mousewheel={{
        releaseOnEdges: true
      }}
          scrollbar={{
            draggable: true,
            snapOnRelease: false
          }}
          modules={[FreeMode, Mousewheel, Scrollbar]}
          onTouchStart={stopParent}
          onTouchEnd={startParent}
        >
          <SwiperSlide>
            <ul className="card-details__contents-list">
            {
              contents.map((item) => (
                <li className="card-details__contents-list-item" key={item.title}>
                  <span>{item.title}</span>
                  <span>{item.text}</span>
                </li>
              ))
            }
          </ul>
          </SwiperSlide>
        </Swiper>
      </section>
      <ActiveItemDivider />
    </>
  )
}

export default ActiveItemContents;
